import { getTomorrowsDate, isDateOverdue } from '@utils/date';

import { EBenefitState, EConflictTag, ELoyaltyType, ILoyaltyItem } from '../../model';
import { IFreeDeliveryBenefit } from '../../utils';

import { IDiscountWrapper } from './LoyaltyDiscountItem/components';

export const getStandardBenefits = (benefits: ILoyaltyItem[]): IDiscountWrapper[] => {
  const standardBenefits = benefits.filter(
    (benefit) =>
      benefit.loyaltyType !== ELoyaltyType.FREE_DELIVERY &&
      benefit.percentageValue &&
      benefit.loyaltyType &&
      benefit.localizedNavigationName,
  );

  return standardBenefits.map<IDiscountWrapper>((benefit) => ({
    percentValue: benefit.percentageValue!,
    discountListName: benefit.localizedNavigationName!,
    isDisabled: benefit.state === EBenefitState.DISABLED,
    discountType: benefit.loyaltyType,
    isPartiallyDisabled: benefit.tags.includes(EConflictTag.CONFLICT_WITH_VOUCHER),
    priceValue: benefit.value,
  }));
};

/**
 * Decide whether to render free delivery benefit
 *
 * - If free delivery benefit is enabled in country, benefit should be rendered
 *
 * - If free delivery benefit is DISABLED in country
 * - - Render benefit if user has benefit active
 * - - Render benefit if user has benefit DISABLED - due to some condition (e.g. unsubscribed from newsletter)
 * - - DO NOT render benefit if user has expired benefit
 *
 * @param benefit - customer free delivery benefit
 * @param isFreeDeliveryBenefitActive - country feature switch
 */
export const shouldBeDeliveryBenefitDisplayed = (
  benefit: IFreeDeliveryBenefit | null,
  isFreeDeliveryBenefitActive: boolean,
): boolean => {
  if (isFreeDeliveryBenefitActive) {
    return true;
  }

  if (!benefit) {
    return false;
  }

  if (benefit.state === EBenefitState.NOT_EXIST_FOR_USER) {
    return false;
  }

  return !benefitIsExpired(benefit);
};

/**
 * Decides if free delivery customer benefit is already expired or just disabled due to other condition (e.g. user unsubscribed from newsletter)
 * @param benefit - Free delivery benefit
 */
const benefitIsExpired = (benefit: IFreeDeliveryBenefit) =>
  isDateOverdue(benefit.date ?? getTomorrowsDate()) && benefit.state === EBenefitState.DISABLED;
